import Tippy from '@tippyjs/react';

import { cn, spaceToKebabCase } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Allowed from 'components/shared/Permissions/Allowed';

const Item = ({ item, isActive, onClick }) => {
  if (item?.hidden) return null;

  const handleClick = () => {
    onClick?.(item);
  };

  return (
    <Allowed requiredPermissions={item?.permission}>
      <Tippy className="tippy-dark" disabled={!item.description} content={item.description}>
        <div
          tabIndex="0"
          data-qa={`sidebar-${spaceToKebabCase(item.label)}`}
          onClick={handleClick}
          className={cn(
            'relative m-0 flex cursor-pointer items-center !gap-2 rounded-[4px] !p-2 text-sm leading-5',
            item.disabled && '',
            isActive
              ? 'bg-primary-50 font-500 text-primary-500 hover:text-primary-500'
              : 'text-neutral-800 hover:bg-neutral-75 hover:text-neutral-800'
          )}>
          {item.icon && (
            <Icon
              icon={item.icon}
              color={isActive ? 'primary' : 'neutral'}
              shade={isActive ? 500 : 800}
              size={16}
            />
          )}
          <span className="truncate">{item.label}</span>
        </div>
      </Tippy>
    </Allowed>
  );
};

export default Item;
